<template>
    <DCard
        footer-padding
    >
        <div class="search">
            <DButton
                :label="__('administrations.cron_jobs.filter_button.never_executed')"
                mini
                :href="cronJobsFilterLink(filterType.neverExecuted)"
            />
            <DButton
                :label="__('administrations.cron_jobs.filter_button.not_executed_today')"
                mini
                :href="cronJobsFilterLink(filterType.notExecutedToday)"
            />
            <DButton
                :label="__('administrations.cron_jobs.filter_button.reset_filter')"
                mini
                :href="cronJobResetLink()"
            />
        </div>
        <DRow>
            <DCol>
                <DTable
                    :items="cronJobs.items"
                    :fields="fields"
                >
                    <template #status="{item}">
                        <td v-if="item.status === 'active'">
                            <DTag
                                color="success"
                                :label="__('administrations.cron_jobs.table.statuses.active')"
                            />
                        </td>
                        <td v-if="item.status === 'disabled'">
                            <DTag
                                color="danger"
                                :label="__('administrations.cron_jobs.table.statuses.disabled')"
                            />
                        </td>
                        <td v-if="item.status === 'irrelevant'">
                            <DTag
                                color="info"
                                :label="__('administrations.cron_jobs.table.statuses.irrelevant')"
                            />
                        </td>
                    </template>
                    <template #rundeck_job="{item}">
                        <td>
                            <a
                                v-if="item.rundeck_job"
                                :href="item.rundeck_job"
                                target="_blank"
                            >
                                <DIcon name="open-in-new" />
                            </a>
                        </td>
                    </template>
                    <template #summary="{item}">
                        <td>
                            {{ getSummaryText(item) }}
                        </td>
                    </template>
                    <template #actions="{item}">
                        <td>
                            <div style="display: flex; grid-gap: 10px; justify-content: end;">
                                <DButton
                                    v-if="item.active === false && item.relevant === true"
                                    icon="check-circle-outline"
                                    :label="__('administrations.cron_jobs.table.activate')"
                                    mini
                                    @click="reactivateJob(item.id)"
                                />
                                <DButton
                                    v-if="item.relevant === true"
                                    icon="import"
                                    mini
                                    @click="displayCronJobModal(item)"
                                />
                                <DButton
                                    icon="pencil"
                                    mini
                                    @click="$inertia.get(editJob(item.id))"
                                />
                            </div>
                        </td>
                    </template>
                </DTable>
                <DPagination
                    v-if="cronJobs.last_page > 1"
                    :active-page="cronJobs.current_page"
                    :pages="cronJobs.last_page"
                    align="center"
                    @update:activePage="changePage"
                />
            </DCol>
        </DRow>
        <ShowCronJobModal
            v-if="showCronJobModal"
            v-model:show="showCronJobModal"
            :item="modalItem"
            is-error
            @close="showCronJobModal = false"
        />
    </DCard>
</template>

<script>
import App from '~@/App.vue'
import CronJobLayout from '~@/Pages/Administrations/CronJobs/Layout.vue'
import ShowCronJobModal from '~@/Components/Administrations/CronJobs/ShowCronJobModal'

export default {
    name: 'CronJobIndex',
    components: {
        ShowCronJobModal
    },
    layout: [App, CronJobLayout],
    props: {
        cronJobs: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            fields: [
                { key: 'job', label: this.__('administrations.cron_jobs.table.job') },
                { key: 'status', label: this.__('administrations.cron_jobs.table.status') },
                { key: 'last_execution', label: this.__('administrations.cron_jobs.table.last_execution') },
                { key: 'summary', label: this.__('administrations.cron_jobs.table.summary') },
                { key: 'rundeck_job', label: this.__('administrations.cron_jobs.table.rundeck_job') },
                { key: 'actions', label: '' }
            ],
            filterType: {
                neverExecuted: 'neverExecuted',
                notExecutedToday: 'notExecutedToday'
            },
            showCronJobModal: false,
            modalItem: null
        }
    },
    methods: {
        editJob (id) {
            return this.$route('administrations.cron-jobs.edit', {
                cron_job: id
            })
        },
        reactivateJob (id) {
            this.$inertia.post(this.$route('administrations.cron-jobs.activate', {
                cron_job: id
            }))
        },
        changePage (page) {
            const query = {}

            if (page > 1) {
                query.page = page
            }

            if (this.cronJobs.filter) {
                query.filter = this.cronJobs.filter
            }

            this.$inertia.get(this.$route('administrations.cron-jobs.index'), query)
        },
        isActive (active) {
            return active === true ? this.__('administrations.cron_jobs.table.active') : this.__('administrations.cron_jobs.table.deactivated')
        },
        cronJobsFilterLink (filterType) {
            return this.$route('administrations.cron-jobs.index', {
                filter: filterType
            })
        },
        cronJobResetLink () {
            return this.$route('administrations.cron-jobs.index')
        },
        displayCronJobModal (item) {
            this.modalItem = item
            this.showCronJobModal = true
        },
        getSummaryText (item) {
            if (item.active) {
                return item.summary
            }

            return item.summary
                ? this.__('administrations.cron_jobs.messages.' + item.job + '.' + item.summary)
                : this.__('administrations.cron_jobs.messages.manually_disabled')
        }
    }
}
</script>

<style lang="scss" scoped>
.search {
    padding: 7px 7px 7px 14px;
}
</style>
